var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0769 3.84616H7.92306C7.37077 3.84616 6.92306 4.29388 6.92306 4.84616V5.53847H9.0769V4.84616C9.0769 4.29388 8.62919 3.84616 8.0769 3.84616ZM4.92306 4.84616V5.5443C3.89037 5.62286 3.0769 6.48566 3.0769 7.53847V12.1539C3.0769 13.2584 3.97233 14.1539 5.0769 14.1539H10.9231C12.0276 14.1539 12.9231 13.2584 12.9231 12.1539V7.53847C12.9231 6.48566 12.1096 5.62286 11.0769 5.5443V4.84616C11.0769 3.18931 9.73376 1.84616 8.0769 1.84616H7.92306C6.2662 1.84616 4.92306 3.18931 4.92306 4.84616ZM9.23075 9.23078C9.23075 9.68634 8.98324 10.0841 8.61537 10.2969V11.0769C8.61537 11.4168 8.33985 11.6923 7.99998 11.6923C7.66011 11.6923 7.3846 11.4168 7.3846 11.0769V10.2969C7.01672 10.0841 6.76921 9.68633 6.76921 9.23078C6.76921 8.55104 7.32025 8.00001 7.99998 8.00001C8.67972 8.00001 9.23075 8.55104 9.23075 9.23078Z",
    fill: "#808589"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.30f54542f2b1ae5d2963d03b5df60a24.svg";
export { ForwardRef as ReactComponent };